/**
 * created by lei lei
 *关联选题详情
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Modal, Row} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import relationChoose from "./img/relationChoose.png";
import SpacerBlock from "../spacerBlock/SpacerBlock";
import *as actions from"../../../actions/manuscriptPool";
import {getByAccounts} from "../../../actions/topicSelection";
import {STATUTS_MAP} from "../../../components/topicSelection/topicSelectionList";

export default class RelationSelectTopicDetail extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions=actions;
        this.state = {
            chooseVisible: false,
            data:{}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    selectTopicDetailDetailShow(data){
       this.topicSelectionGetById(data);
       this.loadUser(data);
    }
   topicSelectionGetById(id){
        let body={
            id:id,//先写死的数据
        };
        this.actions.topicSelectionGetById(body,data=>{
            if(data&&data.data){
                this.setState({chooseVisible:true,data:data.data})
            }

        })
    }

    users = [];//这里做一个缓存，免得每次都去查询

    loadUser(data){
        let accounts = [];
        data.tsCreateBy && data.tsCreateBy.map(account =>{
            let isAdd = true;
            this.users.map(user=>{
                if(user && (user.account === account)){
                    isAdd = false;
                }
            });
            isAdd && (accounts.indexOf(account)===-1) && accounts.push(account);
        });


        data.tsAppointee && data.tsAppointee.map(account =>{
            let isAdd = true;
            this.users.map(user=>{
                if(user && (user.account === account)){
                    isAdd = false;
                }
            });
            isAdd && (accounts.indexOf(account)===-1) && accounts.push(account);
        });

        (accounts.length > 0) && getByAccounts(accounts.join(",")).then(userList=>{
            userList && userList.map(_user=>{
                let isAdd = true;
                this.users && this.users.map(user=>{
                    if(_user && user && _user.account && user.account ){
                        (_user.account === user.account) && (isAdd = false)
                    }
                });
                isAdd && this.users.push(_user);
            });
            this.setState({});
        })
    }


    renderUserNames (accounts){
        let userNames = [];
        this.users && this.users.map(user=>{
            let find = false;
            accounts && accounts.map(account=>{
                user && (user.account === account) && (find = true);
            });
            find && userNames.push(user.name);
        });
        return userNames.join(",");
    }

    render() {
        let data=this.state.data;
        let tsCreateByList=data.tsCreateByList?data.tsCreateByList.toString().replace(/,/g,'、'):'';
        return (
            <div>
                <Modal
                    title={'选题信息'}
                    visible={this.state.chooseVisible}
                    onOk={() => {

                    }}
                    okText={'确认选择'}
                    cancelText={'取消关联'}
                    width={1000}
                    bodyStyle={{padding: 0}}
                    onCancel={() => {
                        this.setState({chooseVisible: false})
                    }}
                    footer={null}
                >

                    <div style={{height: '65vh', padding: 20}} className={'Relation'}>
                        <Scrollbars>
                            <Row>
                                <Col span={8} className={'title'}><div>选题名称</div></Col>
                                <Col span={8} className={'title'}><div>涉及单位</div></Col>
                                <Col span={8} className={'title'}><div>联系人</div></Col>
                                {/* <Col span={8} className={'title'}><div>联系方式</div></Col> */}
                            </Row>
                            <Row style={{marginTop: 10}}>
                                <Col span={8}><div className={'content'} title={data.tsName} >{data.tsName}</div></Col>
                                <Col span={8}><div className={'content'} >{data.tsCompany}</div></Col>
                                <Col span={8}><div className={'content'} >{data.tsContactsName}</div></Col>
                            </Row>
                            <div >
                                <Row style={{marginTop: 20}}>
                                    {/* <Col span={8} className={'title'}><div>联系人</div></Col> */}
                                    <Col span={8} className={'title'}><div>联系方式</div></Col>
                                    <Col span={8} className={'title'}><div>提交时间</div></Col>
                                    <Col span={8} className={'title'}><div>提交人</div></Col>
                                    
                                </Row>
                                <Row style={{marginTop: 10}}>
                                    <Col span={8}><div className={'content'} >{data.tsContactsPhone}</div></Col>
                                    <Col span={8}><div className={'content'} >{data.tsCreateTime}</div></Col>
                                    <Col span={8}><div className={'content'} >{data.tsCreateByName?data.tsCreateByName.toString():''}</div></Col>
                                </Row>
                            </div>
                            <div >
                                <Row style={{marginTop: 20}}>
                                    {/* <Col span={8} className={'title'}><div>联系人</div></Col> */}
                                    <Col span={8} className={'title'}><div>选题状态</div></Col>
                                    <Col span={8} className={'title'}><div>指派给</div></Col>
                                </Row>
                                <Row style={{marginTop: 10}}>
                                    <Col span={8}><div className={'content'} >{ data.tsStatus && STATUTS_MAP["type_"+ data.tsStatus].name}</div></Col>
                                    <Col span={8}><div className={'content'} >{data.tsAppointeeName && data.tsAppointeeName.join(',')}</div></Col>
                                </Row>
                            </div>
                            <div className={'title'} style={{marginTop: 20}}>选题内容</div>
                            <div  style={{marginTop: 10 ,fontSize:14,color: '#808eb5'}}>
                                {data.tsContent}</div>
                        </Scrollbars>
                    </div>
                </Modal>
            </div>
        )
    }

}